import { searchTermConstants } from '../_constants'

export const searchTermActions = {
  setSearchTerm,
}

function setSearchTerm(searchTerm) {
  return { type: searchTermConstants.SET_SEARCH_TERM, searchTerm }
}
